import { render, staticRenderFns } from "./OnboardingFirstQuestion.vue?vue&type=template&id=5a827a70"
import script from "./OnboardingFirstQuestion.vue?vue&type=script&lang=js"
export * from "./OnboardingFirstQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports